import { RowCrudStatus } from "../../common/types";
import {
  SignedEditionSadaicWorkflowState,
  SignedEditionSadaicWorkflowStateCreateMutationVariables,
  SignedEditionSadaicWorkflowStateUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type SignedEditionSadaicWorkflowStateValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name_es: string;
  name_en: string;
  name_pt: string;
};

export type SignedEditionSadaicWorkflowStateErrorsType = {
  name_es?: { message: string; fieldLabel: string };
  name_en?: { message: string; fieldLabel: string };
  name_pt?: { message: string; fieldLabel: string };
};

export function SignedEditionSadaicWorkflowStateValuesInit(): SignedEditionSadaicWorkflowStateValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name_es: "",
    name_en: "",
    name_pt: "",
  };
}

export type SignedEditionSadaicWorkflowStateType =
  | SignedEditionSadaicWorkflowState
  | SignedEditionSadaicWorkflowStateValuesType;

export function signedEditionSadaicWorkflowStateDisplayId(
  source: Partial<SignedEditionSadaicWorkflowState>,
  _langStore: LangStore
) {
  return `${
    source[
      _langStore.fieldByLang(
        "name"
      ) as keyof SignedEditionSadaicWorkflowStateType
    ]
  }`;
}

export function getSignedEditionSadaicWorkflowStateValues(
  source: SignedEditionSadaicWorkflowStateType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SignedEditionSadaicWorkflowStateValuesType {
  const entityValues = SignedEditionSadaicWorkflowStateValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : signedEditionSadaicWorkflowStateDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name_es = source.name_es;
  entityValues.name_en = source.name_en;
  entityValues.name_pt = source.name_pt;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getSignedEditionSadaicWorkflowStateUpdateVariables(
  values: SignedEditionSadaicWorkflowStateValuesType
): SignedEditionSadaicWorkflowStateUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
  };
}

export function getSignedEditionSadaicWorkflowStateCreateVariables(
  values: SignedEditionSadaicWorkflowStateValuesType
): SignedEditionSadaicWorkflowStateCreateMutationVariables {
  return {
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
  };
}
